<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AMLV3e/tc-custom/9781035834808.jpg?1723231596542" alt="This image is the cover for the book Picture Perf*cked"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Picture Perf*cked
      </h1>
      <p class="bookDescription body article font2">
        <p>Now in my thirties, a mum, and wife, I don’t have time to worry about whether I’m doing life right. The reality is that I know, as a matter of fact, that my one and only precious life is moving at a pace that makes me a little uncomfortable, to be honest. And if I want to do something grand and brag-worthy, I better do it before 5 pm because daycare is strict about pickup time. Whether you believe you need to keep up with the Kardashians or keep up with Baker’s day and Karen at school, this book is here for women who need a subtle reminder that they are doing just fine and that shit happens to everyone—even Karen. Disclaimer: This book is not A pity party collection of bummer stories. A comparison as to who’s got it better. Or worse. A “how-to” guide on living your best life. In fact, it is a collection of stories inspired by women and how we all come together and appear to live picture-perfect lives. It’s a slight unveiling of the truth behind the perfect red lips and the limited-edition designer handbags.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alisha Ramasar
      </h2>
      
      <p class="authorDescription body article">Alisha Ramasar is a unique hybrid of a sunshine-yellow and cool-blue-personality. She is an award-winning International Cannes Lion advertising agency recipient. She has the ability to conceptualise, visualise, optimise and quite frankly, kick some ass into gear. She is an innovator, a strategist, a fashionable-foodie-fanatic that loves to add something special to simply…‘doing’. She is a proud wife and a mummy of two princess-superhero girls who inspired this entire book. She aspires to take a break and rest, but somehow keeps on agreeing to do more sh*t that gets in the way of her taking a break and resting.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4334ac11